import React from 'react';
import { Trans } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import UserLink from '../../../User/Link/UserLink';
import s from './ContentByUser.scss';
var ContentByUser = function (_a) {
    var i18nSubKey = _a.i18nSubKey, user = _a.user, contentUrl = _a.contentUrl, biData = _a.biData, contentTitle = _a.contentTitle;
    var updated_sidebar_styles = useFlag('updated_sidebar_styles');
    return updated_sidebar_styles ? (React.createElement(BiLink, { className: s['root-updated_sidebar_styles'], href: contentUrl, biData: biData }, contentTitle)) : (React.createElement("div", { className: s['root'] },
        React.createElement(Trans, { i18nKey: "sidebar.blockTitle.".concat(i18nSubKey) },
            React.createElement(BiLink, { className: s['content-link'], href: contentUrl, biData: biData }, { title: contentTitle }),
            "\u00A0by\u00A0",
            React.createElement(UserLink, { user: user, className: s['by-author'] }))));
};
ContentByUser.displayName = 'ContentByUser';
export default ContentByUser;
//# sourceMappingURL=ContentByUser.js.map